import TransactionsTable from './transection-table';

export const RecentTransections = () => {
    return <TransactionsTable />;
};
